import { useState } from "react";
import { React } from "react-router-dom";
import FlashCard from "./FlashCard";
import FlashCardDeck from "./FlashCardDeck";

export default function FlashCardManager()
{
    const [postion, setPosition] = useState({ x: 0, y: 0 });
    // HACK: this will need to be changed for a changing list of cards (it's currently a mvp for ordering, window selection on top)
    const [order, setOrder] = useState([1,2,3]); 

    const hMouseMove = (event) => {
      setPosition({ x: event.clientX, y: event.clientY });
    };

    // Update the ordering of the elements
    // Window in focus analgum, the top window should handle mouse events first.
    const hOnSelection = (key) => {
      // Finds the selected card are brings it to the top of the dom
      const index = order.findIndex(item => item === key)
      if (index !== -1)
      {
        let newOrder = order;
        newOrder.push(newOrder.splice(index, 1)[0]);
        setOrder(newOrder);
      }
    };

    return (
      <div className="cardBase" onMouseMove={hMouseMove}>
        <FlashCardDeck></FlashCardDeck>
        {order.map((num) => (
          <FlashCard name={num} key={num} position={postion} onSelection={hOnSelection}></FlashCard>
        ))}
      </div>
    );
}